/* eslint-disable */

/** A form of payment that Square accepts for money transfer. */
export enum InstrumentType {
  UNKNOWN = "UNKNOWN",
  VISA = "VISA",
  MASTER_CARD = "MASTER_CARD",
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  DISCOVER = "DISCOVER",
  DISCOVER_DINERS = "DISCOVER_DINERS",
  JCB = "JCB",
  BALANCE = "BALANCE",
  UNION_PAY = "UNION_PAY",
  SQUARE_GIFT_CARD_V2 = "SQUARE_GIFT_CARD_V2",
  INTERAC = "INTERAC",
  SQUARE_CAPITAL_CARD = "SQUARE_CAPITAL_CARD",
  EFTPOS = "EFTPOS",
  FELICA = "FELICA",
  ALIPAY = "ALIPAY",
  CASH_APP = "CASH_APP",
  EBT = "EBT",
  PAYPAY = "PAYPAY",
  AFTERPAY = "AFTERPAY",
  SQUARE_ACCOUNT_BALANCE = "SQUARE_ACCOUNT_BALANCE",
  AU_PAY = "AU_PAY",
  MERPAY = "MERPAY",
  RAKUTEN_PAY = "RAKUTEN_PAY",
  D_BARAI = "D_BARAI",
  WECHAT_PAY = "WECHAT_PAY",
  STORED_VALUE = "STORED_VALUE",
  QUICPAY = "QUICPAY",
  ID = "ID",
  TRANSPORTATION_IC = "TRANSPORTATION_IC",
  /**
   * CASH_LOCAL - CASH_LOCAL was a misnaming of the Local Cash payment method; new code should use LOCAL_CASH.
   *
   * @deprecated
   */
  CASH_LOCAL = "CASH_LOCAL",
  LOCAL_CASH = "LOCAL_CASH",
}
